export default {
  methods: {
    clearTableCrosshair(root) {
      if (!root) return
      root.querySelectorAll('.bdc-table-crosshair-row, .bdc-table-crosshair-col, .bdc-table-crosshair-active')
        .forEach(el => el.classList.remove('bdc-table-crosshair-row', 'bdc-table-crosshair-col', 'bdc-table-crosshair-active'))
    },

    handleCellMouseEnter(row, column, cell) {
      if (!this.isBdc || !cell || !column) return
      const root = cell.closest('.bdc-crosshair-table')
      if (!root) return
      this.clearTableCrosshair(root)

      const rowEl = cell.parentElement
      if (!rowEl || rowEl.tagName !== 'TR') return

      const rowIndex = Array.from(rowEl.parentElement.children).indexOf(rowEl)
      root.querySelectorAll('tbody').forEach(tbody => {
        const tr = tbody.children[rowIndex]
        if (tr) {
          Array.from(tr.children).forEach(td => td.classList.add('bdc-table-crosshair-row'))
        }
      })

      if (column.id) {
        root.querySelectorAll(`td.${column.id}, th.${column.id}`).forEach(el => {
          el.classList.add('bdc-table-crosshair-col')
        })
      }

      cell.classList.add('bdc-table-crosshair-active')
    },

    handleCellMouseLeave(row, column, cell, event) {
      if (!this.isBdc) return
      const root = cell && cell.closest('.bdc-crosshair-table')
      if (root && event.relatedTarget && root.contains(event.relatedTarget)) return
      this.clearTableCrosshair(root)
    }
  }
}
